import Text from '../../../Text'

import * as styles from './CalendarRailBlock.module.css'

function CalendarRailBlock({ children, title }) {
  return (
    <div className={styles.CalendarRailBlock}>
      <Text isSecondary>{title}</Text>
      {children}
    </div>
  )
}

export default CalendarRailBlock
